/* tslint:disable */
/* eslint-disable */
/**
 * Notifications API
 * An API to create and read notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: DevTeamProduct@digitalrealty.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface PaginatedResponse
 */
export interface PaginatedResponse {
    /**
     * Pagination link|cursor pointing to the current page.
     * @type {string}
     * @memberof PaginatedResponse
     */
    self?: string;
    /**
     * Pagination link|cursor pointing to the first page.
     * @type {string}
     * @memberof PaginatedResponse
     */
    first?: string;
    /**
     * Pagination link|cursor pointing to the previous page.
     * @type {string}
     * @memberof PaginatedResponse
     */
    prev?: string;
    /**
     * Pagination link|cursor pointing to the next page.
     * @type {string}
     * @memberof PaginatedResponse
     */
    next?: string;
    /**
     * Pagination link|cursor pointing to the last page.
     * @type {string}
     * @memberof PaginatedResponse
     */
    last?: string;
    /**
     * Array of collection items.
     * @type {Array<any>}
     * @memberof PaginatedResponse
     */
    items: Array<any>;
}

/**
 * Check if a given object implements the PaginatedResponse interface.
 */
export function instanceOfPaginatedResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

export function PaginatedResponseFromJSON(json: any): PaginatedResponse {
    return PaginatedResponseFromJSONTyped(json, false);
}

export function PaginatedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'self': !exists(json, 'self') ? undefined : json['self'],
        'first': !exists(json, 'first') ? undefined : json['first'],
        'prev': !exists(json, 'prev') ? undefined : json['prev'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'last': !exists(json, 'last') ? undefined : json['last'],
        'items': json['items'],
    };
}

export function PaginatedResponseToJSON(value?: PaginatedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'self': value.self,
        'first': value.first,
        'prev': value.prev,
        'next': value.next,
        'last': value.last,
        'items': value.items,
    };
}

